import { useRouter } from 'next/router';
import { useCallback } from 'react';
import { Image } from '@components/common/Image';
import { SimpleImage } from '@components/common/SimpleImage';
import { UiKitButton } from '@components/common/ui-kit-button';
import { Container } from '@features/Unsubscribe/components/Container';
import { Title } from '@features/Unsubscribe/components/Title';
import { useUnsubscribeAnalytics } from '@features/Unsubscribe/hooks/use-unsubscribe-analytics';
import { closeWebView } from '@features/Unsubscribe/utils/close-web-view';
import styles from './DiscountActivated.module.scss';
export const DiscountActivated = () => {
  const {
    query
  } = useRouter();
  const {
    origin
  } = query;
  const {
    defaultEventOptions,
    trackUnsubscribeEvent
  } = useUnsubscribeAnalytics();
  const handleDone = useCallback(() => {
    trackUnsubscribeEvent('cancel_discount_activated_close_tapped');
    if (origin === 'app') {
      closeWebView();
    } else {
      window.close();
    }
  }, [origin, trackUnsubscribeEvent]);
  return <Container className={styles.container} eventOnMounted="cancel_discount_activated_opened" eventOptions={defaultEventOptions} data-sentry-element="Container" data-sentry-component="DiscountActivated" data-sentry-source-file="index.tsx">
      <div className={styles.imageWrapper}>
        <Image src="discount-activated.webp" alt="gift-premium" layout="fill" data-sentry-element="Image" data-sentry-source-file="index.tsx" />
      </div>

      <div className={styles.card}>
        <SimpleImage className={styles.icon} src="switch.svg" width="37" height="21" alt="discount" data-sentry-element="SimpleImage" data-sentry-source-file="index.tsx" />
        <span>special discount</span>
      </div>

      <Title className={styles.title} data-sentry-element="Title" data-sentry-source-file="index.tsx">Your discount is activated</Title>
      <p className={styles.subtitle}>
        Your subscription is active, but you can still cancel it anytime. See
        you!
      </p>

      <UiKitButton onClick={handleDone} className={styles.button} fullWidth data-sentry-element="UiKitButton" data-sentry-source-file="index.tsx">
        Close
      </UiKitButton>
    </Container>;
};